/* LUCIELL — Messpunkte fuer Warenkorb und Abschluss
   ==========================================================================

   Schickt acht anonyme Zaehlstaende an den Worker luciell-metrik:

     korb_auf           der Schieber ist aufgegangen (oder /cart wurde geladen)
     kasten_auf         der Upsell-Kasten ist aufgegangen
     hinzu              etwas ist im Korb gelandet — mit Herkunft und Varianten-ID
     kasse_klick        "Jetzt sicher zur Kasse" wurde gedrueckt
     karussell_gesehen  das Warenkorb-Karussell war zum ersten Mal im Bild
                        (A/B-Test, meldet lc-korb.js)
     charm_hinzu        ein CH-Charm kam aus dem Karussell in den Korb, mit
                        Stueckpreis nach Planrabatt (meldet lc-korb.js)
     pdp_gesehen        eine Editions-Seite wurde aufgerufen, waehrend ein Test
                        vom typ "produktseite" laeuft — mit Varianten-ID und
                        Preis der Variante im Kaufen-Zettel (meldet diese Datei)
     test_gesehen       eine beliebige Shop-Seite wurde geladen, waehrend ein
                        shopweiter Test laeuft (typ "preisfarbe") — hoechstens
                        einmal je Besucher, Test und Berliner Tag, ohne
                        Herkunft, Produkt und Wert (meldet diese Datei)

   A/B-Test (Spec 2026-10-02, Vertrag K4): solange window.lcAb gesetzt ist
   (Auslosung in snippets/lc-ab-auslosung.liquid), traegt JEDES Ereignis
   `test` und `variante`. Die alte eigene 50/50-Gruppe (`lc_test_gruppe`,
   Feld `gruppe`) ist abgeschafft — es gibt genau EINE Auslosung.

   Damit bekommt jede Quote endlich einen NENNER. Das Business-OS zeigt
   Bestellungen; Bestellungen ohne Nenner sind keine Quote. "Der Kasten hat 55
   Stueck verkauft" klingt gut, bis jemand fragt, wie vielen er dafuer gezeigt
   wurde.

   ─── DIE WICHTIGSTE REGEL ──────────────────────────────────────────────────
   DER KAUF DARF AN DIESER DATEI NIEMALS HAENGEN. Deshalb:
     - Diese Datei fasst window.fetch NICHT an. Genau dafuer wurde
       luciell-gift-pouch ausgehaengt (theme.liquid, Task 7).
     - Sie umhuellt window.lcKorb.hinzufuegen NICHT. Das erwischte ohnehin nur
       die Aufrufe aus lc-kasten.js (steht so in lc-kasten.js ab Zeile 388).
     - Gemeldet wird von den Stellen aus, die es WISSEN: lc-korb.js und
       lc-kasten.js rufen hier herein. Vier Zeilen dort, kein Zauber hier.
     - Jeder Aufruf steht in einem try/catch, gesendet wird per sendBeacon
       (feuern und vergessen). Faellt diese Datei ganz aus, laeuft der Shop
       weiter — die Aufrufer fragen vorher, ob es sie gibt.

   ─── VORSCHAU MISST NICHT MIT (Betreiber 03.10.2026, „Beides") ───────────
   Befund 03.10.: Vorschau- und Entwurfs-Themes schrieben in denselben Test
   wie Live. Seitdem sendet nur das VEROEFFENTLICHTE Theme. Massgeblich ist
   window.Shopify.theme.role aus content_for_header (gemessen per curl am
   03.10.): live "main", jede Vorschau per ?preview_theme_id= "unpublished",
   `shopify theme dev` "development". Im Theme-Editor setzt Shopify dazu
   Shopify.designMode — dort wird auch beim Live-Theme nicht gesendet.
     - Es entfaellt NUR das Senden. Kennung, A/B-Auslosung
       (lc-ab-auslosung.liquid), Marke und alle Aufrufe laufen wie live, damit
       die Vorschau zeigt, was live passiert. Ob gesendet wird, steht in der
       Konsole unter window.lcMetrik.sendet.
     - Fehlt Shopify.theme oder seine role ganz: senden wie bisher. Lieber
       messen als still verlieren — rausrechnen kann das Cockpit, eine nie
       gesendete Zeile holt niemand zurueck.

   HINTERTUER fuer bewusste Messproben in der Vorschau (nur dort wirksam):
     ?lc_metrik=probe   Probe AN fuer dieses Geraet. Gemerkt in localStorage
                        `lc_metrik_probe` = '1', ueberlebt also den
                        Seitenwechsel (Shopifys Vorschau-Weiterleitung laesst
                        den Parameter stehen, geprueft 03.10.).
     ?lc_metrik=aus     Probe AUS, der Schluessel wird geloescht.
   Im Live-Theme wirkt keins von beiden: es sendet immer, und ein Link mit
   ?lc_metrik=aus kann die Messung dort nicht abdrehen.
   ⚠️ Probe-Ereignisse tragen test/variante wie echte und landen im Test —
   die Besucher-Kennung des Probe-Geraets gehoert auf die Ausschlussliste im
   Cockpit (Reiter „Tests").

   ─── DATENSPARSAMKEIT ──────────────────────────────────────────────────────
   Gesendet wird: Zufallskennung, Ereignisname, Herkunft, Varianten-ID,
   Testgruppe, Warenkorbwert in Cent. Sonst nichts. Keine IP, kein Browser,
   kein Verweis, kein Name, keine Adresse — dafuer gibt es hier kein Feld und
   im Worker keine Spalte. Die Kennung entsteht im Browser, wird nirgends mit
   einer Bestellung, einem Konto oder einer Adresse verknuepft und ist von
   aussen nicht aufloesbar.

   OHNE localStorage PASSIERT GAR NICHTS. Keine Kennung, keine Gruppe, kein
   Messpunkt, keine Zeilen-Eigenschaft. Lieber keine Daten als falsche: ohne
   stabile Gruppe waere jeder Besuch mal A und mal B, und der A/B-Vergleich
   nicht bloss ungenau, sondern gegenstandslos.
   ========================================================================== */
(function () {
  'use strict';

  /* ── DIE EINE STELLE FUER DIE ZIELADRESSE ────────────────────────────────
     Bewusst hier und NUR hier. Ein zweiter Ort (etwa ein window-Wert in
     theme.liquid) waere eine zweite Wahrheit, die irgendwann auseinanderlaeuft
     — dieselbe Falle wie zwei Versandschwellen im selben Warenkorb. Aendert
     sich der Worker, aendert sich diese Zeile. */
  var ZIEL = '/apps/metrik/e';

  /* Sendeweg (Vertrag K5). 'post' = sendBeacon bzw. fetch-POST mit text/plain
     wie bisher; 'get' = GET ZIEL?d=<JSON> per fetch keepalive ohne Cookies —
     der Rueckfall, falls der App-Proxy keinen POST-Rumpf durchreicht. Den
     Schalter setzt theme.liquid (window.LC_METRIK_WEG); alles ausser 'get'
     gilt als 'post'. */
  var WEG = window.LC_METRIK_WEG === 'get' ? 'get' : 'post';

  /* Schalter fuer die Zeilen-Eigenschaften _lc_q / _lc_v; steht in
     theme.liquid, weil er der einzige Teil ist, der den Kaufweg beruehrt.
     AUS = Schattenbetrieb: die Messpunkte laufen, an /cart/add.js wird nichts
     veraendert. Dann bleibt allerdings die Abschlussquote je Gruppe leer —
     ohne _lc_v kann der Worker eine Bestellung keiner Gruppe zuordnen. */
  var EIGENSCHAFTEN = window.LC_METRIK_EIGENSCHAFTEN !== false;

  var SCHL_BESUCHER = 'lc_besucher';
  var SCHL_PROBE = 'lc_metrik_probe';

  /* Weisse Liste, keine schwarze — dieselbe wie im Worker (src/ereignis.js).
     Sie steht hier ein zweites Mal, damit ein Tippfehler in lc-korb.js nicht
     erst in der Datenbank auffaellt, sondern gar nicht erst losfliegt. */
  var EREIGNISSE = { korb_auf: 1, kasten_auf: 1, hinzu: 1, kasse_klick: 1, karussell_gesehen: 1, charm_hinzu: 1, pdp_gesehen: 1, test_gesehen: 1 };
  /* Dieselben Muster wie Vertrag K1 (Plan) und K4 (Worker). */
  var TEST_MUSTER = /^[a-z0-9][a-z0-9-]{0,39}$/;
  var VARIANTE_MUSTER = /^[a-z][a-z0-9]{0,7}$/;
  /* auswahl1/auswahl2: die Angebots-Auswahl auf den Editions-Seiten (A/B-Test
     „produktseite", Gruppe B) — Kasten „1 Armband" bzw. „Kauf 1, krieg 1
     gratis". Gemeldet von lc-korb.js (hinzufuegenMehrere). */
  var HERKUENFTE = { produktseite: 1, raster: 1, schieber: 1, kasten: 1, auswahl1: 1, auswahl2: 1 };

  /* ── Die stumme Fassung ──────────────────────────────────────────────────
     Steht SOFORT am window, noch vor jeder Pruefung. Steigen wir gleich aus
     (kein localStorage, kein Zufallsgenerator), rufen lc-korb.js und
     lc-kasten.js weiter ins Leere — und ins Leere zu rufen ist billig. Ohne
     diese Fassung muesste jede Aufrufstelle zwei Dinge pruefen statt eines. */
  var still = {
    melden: function () {},
    marke: function () { return {}; },
    laeuft: false,
    sendet: false
  };
  window.lcMetrik = still;

  /* ── Kennung und Gruppe ──────────────────────────────────────────────────
     Beides in EINEM Versuch, und beim ersten Fehler ist Schluss. Ein
     Teilzustand — Kennung ja, Gruppe nein — waere schlimmer als nichts: dann
     liefen Ereignisse ohne Gruppe auf, die im Nenner der Gruppe fehlen, im
     Gesamtzaehler aber stehen. */
  function lager() {
    try {
      var l = window.localStorage;
      if (!l) return null;
      // Schreibprobe. Safari im privaten Modus HAT localStorage und wirft erst
      // beim Schreiben — das faellt sonst beim ersten echten setItem auf, also
      // mitten im Kaufweg.
      l.setItem('lc_probe', '1');
      l.removeItem('lc_probe');
      return l;
    } catch (e) {
      return null;
    }
  }

  var L = lager();
  if (!L) return;
  if (!window.crypto || typeof window.crypto.getRandomValues !== 'function') return;

  function hexId() {
    var a = new Uint8Array(16);
    window.crypto.getRandomValues(a);
    var s = '';
    for (var i = 0; i < a.length; i++) s += ('0' + a[i].toString(16)).slice(-2);
    return s;
  }

  var besucher;
  try {
    besucher = L.getItem(SCHL_BESUCHER);
    if (!/^[0-9a-f]{32}$/.test(besucher || '')) {
      besucher = hexId();
      L.setItem(SCHL_BESUCHER, besucher);
    }
  } catch (e) {
    return;                                    // stumme Fassung bleibt stehen
  }

  /* ── Vorschau oder Live? ─────────────────────────────────────────────────
     Siehe Kopfkommentar. Wird EINMAL beim Laden entschieden: content_for_header
     setzt Shopify.theme inline im <head>, diese Datei laeuft per defer danach.
     Im Zweifel (kein Shopify, kein theme, keine role) gilt Live. */
  function vorschau() {
    try {
      var s = window.Shopify;
      if (!s) return false;
      if (s.designMode) return true;           // Theme-Editor, auch beim Live-Theme
      var t = s.theme;
      if (!t || typeof t.role !== 'string' || !t.role) return false;
      return t.role !== 'main';
    } catch (e) {
      return false;
    }
  }

  /* Die Hintertuer (Kopfkommentar). Wird nur in der Vorschau gelesen — im
     Live-Theme fasst ein ?lc_metrik=… im Link den Speicher nicht an. */
  function probe() {
    try {
      var m = /[?&]lc_metrik=([a-z]+)/.exec(String((window.location && window.location.search) || ''));
      if (m && m[1] === 'probe') L.setItem(SCHL_PROBE, '1');
      else if (m && m[1] === 'aus') L.removeItem(SCHL_PROBE);
      return L.getItem(SCHL_PROBE) === '1';
    } catch (e) {
      return false;
    }
  }

  var SENDET = !vorschau() || probe();

  /* ── Senden ──────────────────────────────────────────────────────────────
     text/plain, NICHT application/json. text/plain ist eine der drei
     CORS-erlaubten Inhaltsarten und macht daraus eine EINFACHE Anfrage: kein
     OPTIONS vorweg. Mit application/json kaeme ein Vorflug, und den wartet ein
     sendBeacon beim Seitenwechsel nicht ab — ausgerechnet kasse_klick, der
     Messpunkt direkt vor dem Verlassen der Seite, fiele lautlos aus. Der
     Worker liest den Rumpf als Text und parst selbst. */
  var TYP = 'text/plain;charset=UTF-8';

  function senden(text) {
    try {
      if (!SENDET) return;                     // Vorschau: alles laeuft, nur nichts geht raus
      if (WEG === 'get') {
        /* GET-Rueckfall (Vertrag K5): der Rumpf faehrt als ?d= in der Adresse.
           Ohne Cookies, `keepalive` ueberlebt den Seitenwechsel (kasse_klick). */
        window.fetch(ZIEL + '?d=' + encodeURIComponent(text), {
          method: 'GET',
          keepalive: true,
          credentials: 'omit'
        })['catch'](function () {});
        return;
      }
      if (navigator.sendBeacon) {
        navigator.sendBeacon(ZIEL, new Blob([text], { type: TYP }));
        return;
      }
      /* Rueckfall fuer Browser ohne sendBeacon. `keepalive`, damit die Anfrage
         den Seitenwechsel ueberlebt. Die Antwort sieht sich niemand an — der
         Worker antwortet ohnehin immer 204 ohne Inhalt. */
      window.fetch(ZIEL, {
        method: 'POST',
        body: text,
        keepalive: true,
        headers: { 'Content-Type': TYP }
      })['catch'](function () {});
    } catch (e) {
      /* Absichtlich still. Ein Messpunkt, der nicht rausgeht, ist eine Luecke
         in einer Statistik. Ein Fehler, der von hier hochschlaegt, waere ein
         abgebrochener Kauf. */
    }
  }

  /* ── Warenkorbwert ───────────────────────────────────────────────────────
     Kommt aus dem Fuss des Schiebers, den lc-korb-summen.liquid serverseitig
     rendert (`data-lc-wert-cent="{{ cart.total_price }}"`). Drei Gruende, es
     so und nicht anders zu holen:

       1. Es ist DIESELBE Quelle wie /cart.js total_price, nur ohne zweite
          Serverrunde — und die zweite Serverrunde ist genau das, was der Umbau
          vom 16.09. abgeschafft hat.
       2. Der Knoten wird bei jedem Neuzeichnen ersetzt, ist also nie alt.
       3. Aus dem sichtbaren Text zu parsen waere falsch: Streichpreis und
          Preis stehen in derselben Zelle.

     Fehlt der Knoten, ist der Korb leer — lc-korb-summen wird dann gar nicht
     gerendert. Das ist gemessen, nicht geraten, also 0 und nicht null. */
  function wertCent() {
    try {
      var k = document.querySelector('[data-lc-wert-cent]');
      if (!k) return 0;
      var roh = k.getAttribute('data-lc-wert-cent') || '';
      // Keine Umwandlung von Muell: lieber null als eine Zahl, die um den
      // Faktor 100 danebenliegt. Dieselbe Haltung wie im Worker.
      if (!/^[0-9]{1,8}$/.test(roh)) return null;
      return Number(roh);
    } catch (e) {
      return null;
    }
  }

  /* ── Melden ──────────────────────────────────────────────────────────────
     Die eine Tuer nach draussen. Unbekannte Ereignisnamen und unbekannte
     Herkuenfte fallen hier heraus statt beim Worker — ein Tippfehler in
     lc-korb.js soll nicht erst in der Datenbank auffallen.

     `produkt` ist die VARIANTEN-ID. Die Produkt-ID kennt der Browser beim
     Klick nicht (dieselbe Falle, die lc-korb.js fuer das Saeckchen
     beschreibt); der Worker loest sie auf. */
  /* `wert` (vierter Parameter) gilt NUR fuer charm_hinzu, pdp_gesehen,
     test_gesehen und `hinzu` aus der Angebots-Auswahl (Herkunft
     auswahl1/auswahl2):
       - charm_hinzu: Stueckpreis nach Planrabatt in Cent, den lc-korb.js aus
         der Karte rechnet (Vertrag K4);
       - pdp_gesehen: Preis der Variante im Kaufen-Zettel;
       - test_gesehen: immer null (Vertrag: der Nenner hat keinen Wert);
       - hinzu aus der Auswahl: Listenpreis der ARMBAND-Zeilen dieser einen
         Anfrage in Cent, vor Rabatten (auswahl1 = 6490, auswahl2 mit zwei
         Editionen = 12980). lc-korb.js rechnet ihn aus den Zeilen, die
         lc-auswahl.js mitgibt. Fehlt er oder ist er unbrauchbar, steht null
         da — NICHT der Korbwert, sonst laegen in derselben Spalte zwei
         verschiedene Bedeutungen.
     Alle anderen Ereignisse (auch `hinzu` aus Produktseite, Raster, Schieber
     und Kasten) tragen weiter den Korbwert aus dem Fuss. Der ist der von VOR
     dem Ablegen (lc-korb.js: „wie voll der Korb war, als die Entscheidung
     fiel"); beim ersten Ablegen in einen leeren Korb also 0.
     Fund 13.10.2026: hinzu aus der Auswahl stand live mit wert_cent 0, obwohl
     zwei Editionen zu je 64,90 EUR abgelegt wurden — daher der eigene Wert. */
  var EIGENER_WERT = { charm_hinzu: 1, pdp_gesehen: 1, test_gesehen: 1 };
  var AUSWAHL_HERKUNFT = { auswahl1: 1, auswahl2: 1 };
  function eigenerWert(name, herkunft) {
    return !!(EIGENER_WERT[name] || (name === 'hinzu' && AUSWAHL_HERKUNFT[herkunft]));
  }
  function ganzerCent(x) {
    return typeof x === 'number' && isFinite(x) && Math.floor(x) === x && x >= 0 && x <= 10000000;
  }

  function melden(name, herkunft, produkt, wert) {
    try {
      if (!EREIGNISSE[name]) return;
      var punkt = {
        name: name,
        besucher: besucher,
        herkunft: HERKUENFTE[herkunft] ? herkunft : null,
        produkt: null,
        wert_cent: eigenerWert(name, herkunft) ? (ganzerCent(wert) ? wert : null) : wertCent()
      };
      if (produkt !== null && produkt !== undefined) {
        var p = String(produkt);
        if (/^[0-9]{1,20}$/.test(p)) punkt.produkt = p;
      }
      /* Test und Variante bei JEDEM Ereignis, solange window.lcAb gesetzt ist
         (Vertrag K4). Kein Test = keine Test-Felder (Vertrag K1). */
      var ab = window.lcAb;
      if (ab && TEST_MUSTER.test(String(ab.test)) && VARIANTE_MUSTER.test(String(ab.variante))) {
        punkt.test = ab.test;
        punkt.variante = ab.variante;
      }
      senden(JSON.stringify(punkt));
    } catch (e) {}
  }

  /* ── Die Marke an der Warenkorbzeile ─────────────────────────────────────
     _lc_q = Herkunft, _lc_v = Testgruppe. Der fuehrende Unterstrich ist
     Shopifys Konvention fuer "technisch": die Kasse und die Bestaetigungsmail
     blenden solche Eigenschaften selbst aus, im Theme tut es
     lc-korb-position.liquid.

     ⚠️ DER FILTER DORT HAT BIS ZUM 17.09.2026 NIE GEFILTERT (`name.first` ist
     bei einer Zeichenkette immer nil). Er ist auf `slice: 0` umgebaut, aber
     nur im Arbeits-Theme. Solange dieser Fix nicht live ist, stuenden _lc_q
     und _lc_v der Kundin sichtbar im Warenkorb — erst der Fix, dann
     LC_METRIK_EIGENSCHAFTEN auf true.

     Gibt bewusst ein NEUES Objekt zurueck und schreibt nirgends hinein. Der
     Aufrufer legt es ueber seine eigenen Eigenschaften. */
  function marke(herkunft) {
    try {
      if (!EIGENSCHAFTEN) return {};
      // _lc_v (alte Testgruppe) gibt es nicht mehr; der A/B-Test markiert
      // ueber _lc_ab, und das setzt lc-korb.js: beim Rabatt-Test das
      // Karussell, beim Produktseiten-Test NUR die Editions-Seite.
      var raus = {};
      if (HERKUENFTE[herkunft]) raus._lc_q = herkunft;
      return raus;
    } catch (e) {
      return {};
    }
  }

  window.lcMetrik = {
    melden: melden,
    marke: marke,
    laeuft: true,
    sendet: SENDET                             // false = Vorschau ohne Probe (nur zum Nachsehen)
  };

  /* ── kasse_klick ─────────────────────────────────────────────────────────
     Der Kasse-Knopf ist ein gewoehnlicher Link auf /checkout
     (lc-korb-summen.liquid), kein Formular — an ihm haengt sonst kein
     Javascript. Darum wird er hier gemessen und nicht in lc-korb.js.

     Ein DELEGIERTER Horcher, niemals einer am Knopf selbst: der Fuss wird bei
     jedem Neuzeichnen komplett ersetzt, ein Horcher am Knopf waere nach der
     ersten Mengenaenderung weg.

     Einfangphase am `window`, aus demselben Grund wie der Schnellkauf-Haken in
     lc-korb.js: wer einen Klick abfaengt und stopPropagation ruft, wuerde uns
     sonst ueberspringen. Wir aendern am Klick NICHTS — kein preventDefault,
     keine Verzoegerung. Der Kauf wartet auf keine Statistik. */
  window.addEventListener('click', function (e) {
    try {
      if (!e.target || !e.target.closest) return;
      if (!e.target.closest('.lc-korb__kasse')) return;
      /* Auf /cart stehen ZWEI Kasse-Knoepfe im selben Dokument: einer im
         Schieber, einer auf der Seite. Beide zaehlen als 'schieber' — es ist
         derselbe Baustein an derselben Stelle der Kaufreise, nur einmal
         ueberlagert und einmal nicht. Getrennt zu zaehlen hiesse, den Nenner
         in zwei zu kleine Haelften zu schneiden. */
      melden('kasse_klick', 'schieber', null);
    } catch (f) {}
  }, true);

  /* ── korb_auf auf der Warenkorbseite ─────────────────────────────────────
     Den Schieber meldet lc-korb.js selbst (in oeffnen(), auf der Flanke zu →
     auf). Auf /cart wird der Schieber aber bewusst NICHT aufgezogen — dort ist
     die Seite die Rueckmeldung (lc-korb.js: `if (!seite()) oeffnen()`). Ohne
     diese Zeilen fehlten alle, die ueber den Kopf der Seite, eine
     Warenkorbabbruch-Mail oder ein Lesezeichen kommen — und das sind
     ausgerechnet die mit Kaufabsicht. */
  function start() {
    try {
      // Nur melden, wenn der Korb etwas enthaelt. Der Knoten [data-lc-wert-cent]
      // entsteht in lc-korb-summen.liquid, und das Snippet rendert bei leerem
      // Korb ueberhaupt nicht — sein Fehlen IST also die Leermeldung.
      // Grund (Pruefbefund 17.09.): wer den Warenkorb leer aufmacht, landete im
      // Nenner von „Vom Schieber zur Kasse" und von der Abschlussquote, ohne je
      // im Zaehler auftauchen zu koennen — es gibt bei leerem Korb gar keinen
      // Kasse-Knopf. Beide Quoten fielen dadurch systematisch zu niedrig aus.
      if (document.querySelector('[data-lc-cart-seite]')
          && document.querySelector('[data-lc-wert-cent]')) melden('korb_auf', null, null);
    } catch (e) {}
  }

  /* ── pdp_gesehen (A/B-Test „Produktseite mit Angebots-Auswahl",
     Spec 2026-10-13) ─────────────────────────────────────────────────────
     Der NENNER dieses Tests: einmal je Seitenaufruf einer Editions-Seite.
     Editions-Seite = die Wurzel von snippets/lc-auswahl.liquid traegt
     data-lc-edition-seite="1". Sie steht nur in den 8 Editions-Vorlagen, in
     BEIDEN Gruppen (in A per CSS verborgen) — so zaehlen A und B gleich.
     Nur solange ein Test vom typ "produktseite" laeuft (window.lcAb.typ aus
     snippets/lc-ab-auslosung.liquid). Ohne Test oder bei einem Rabatt-Test
     geht nichts raus.
     produkt = Varianten-ID im Kaufen-Zettel des Themes ([name="id"]) beim
     Laden, wert = ihr Preis in Cent aus [data-variant-json]
     (snippets/product-form.liquid). Fehlt eins davon, geht der Punkt
     trotzdem raus — mit null an der Stelle. Ein fehlender Nenner waere
     schlimmer als ein Nenner ohne Preis.

     Flagge „Auswahl gesehen" (Review P3-3): in Gruppe B setzt dieselbe Stelle
     localStorage `lc_ab_pdp_<test>` = '1' — die Besucherin hat im Test eine
     Editions-Seite mit der Auswahl gesehen. lc-kasten.js unterdrueckt den
     1+1-Kasten in Gruppe B NUR mit dieser Flagge; wer Armbaender aus einem
     Raster ablegt, ohne je eine Editions-Seite zu oeffnen, behaelt den
     Kasten wie Gruppe A. Gesetzt wird unabhaengig vom Senden (Vorschau
     zeigt, was live passiert); ein Schreibfehler bricht nichts ab. Der
     Schluessel haengt am Test: ein neuer Test beginnt ohne Flagge. */
  var EDITION_SEITE = '[data-lc-edition-seite="1"]';
  var pdpGemeldet = false;

  function pdpFlagge(ab) {
    try {
      if (ab.variante === 'b' && TEST_MUSTER.test(String(ab.test))) L.setItem('lc_ab_pdp_' + ab.test, '1');
    } catch (e) {}
  }

  function pdpZettel(wurzel) {
    var abschnitt = wurzel.closest ? wurzel.closest('.shopify-section') : null;
    return (abschnitt && abschnitt.querySelector && abschnitt.querySelector('form[action*="/cart/add"]'))
      || document.querySelector('form[action*="/cart/add"]');
  }

  function pdpPreis(zettel, id) {
    try {
      var feld = zettel.querySelector('[data-variant-json]');
      if (!feld) return null;
      var liste = JSON.parse(feld.value || feld.textContent || '[]');
      for (var i = 0; i < liste.length; i++) {
        if (liste[i] && String(liste[i].id) === id) return liste[i].price;
      }
    } catch (e) {}
    return null;
  }

  function pdpGesehen() {
    try {
      if (pdpGemeldet) return;
      var ab = window.lcAb;
      if (!ab || ab.typ !== 'produktseite') return;
      var wurzel = document.querySelector(EDITION_SEITE);
      if (!wurzel) return;
      pdpGemeldet = true;
      pdpFlagge(ab);
      var produkt = null;
      var preis = null;
      var zettel = pdpZettel(wurzel);
      var idFeld = zettel && zettel.querySelector('[name="id"]');
      var id = idFeld ? String(idFeld.value || '') : '';
      if (/^[0-9]{1,20}$/.test(id)) {
        produkt = id;
        preis = pdpPreis(zettel, id);
      }
      melden('pdp_gesehen', 'produktseite', produkt, preis);
    } catch (e) {}
  }

  /* ── test_gesehen (A/B-Test „Preisfarbe", typ "preisfarbe", 01.11.2026) ──
     Der NENNER shopweiter Tests: wer war, der Gruppe zugelost, im Shop.
     Jede Seite, BEIDE Gruppen — nur solange window.lcAb gueltig ist und
     typ "preisfarbe" traegt (Rabatt- und Produktseiten-Tests haben ihre
     eigenen Nenner, dort geht nichts raus).
     Hoechstens einmal je Besucher, Test und Berliner Tag: localStorage
     `lc_ab_gesehen_<test>` = Datum in Europe/Berlin (JJJJ-MM-TT). Steht dort
     heute, geht nichts raus. Der Merker wird VOR dem Senden geschrieben und
     zurueckgelesen; klappt das nicht, geht auch nichts raus — lieber ein
     fehlender Nenner-Tag als derselbe Besucher bei jedem Seitenaufruf.
     Gesetzt wird unabhaengig vom Senden (wie pdp_gesehen): die Vorschau
     zeigt, was live passiert. Der Worker entdoppelt nicht, das Cockpit zaehlt
     eindeutige Besucher. */
  var testGemeldet = false;

  /* Kalendertag in Europe/Berlin als JJJJ-MM-TT. Erst Intl (formatToParts —
     die fertige Zeichenkette von en-CA hat sich zwischen Browserstaenden
     schon geaendert), sonst die EU-Sommerzeitregel von Hand: MESZ vom
     letzten Sonntag im Maerz bis zum letzten Sonntag im Oktober, je 01:00 UTC. */
  function berlinTag(jetzt) {
    try {
      var teile = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit'
      }).formatToParts(jetzt);
      var t = {};
      for (var i = 0; i < teile.length; i++) t[teile[i].type] = teile[i].value;
      var tag = t.year + '-' + t.month + '-' + t.day;
      if (/^\d{4}-\d{2}-\d{2}$/.test(tag)) return tag;
    } catch (e) {}
    var ms = jetzt.getTime();
    var j = jetzt.getUTCFullYear();
    function letzterSonntag(monat) {
      var ende = new Date(Date.UTC(j, monat + 1, 0, 1));
      return ende.getTime() - ende.getUTCDay() * 86400000;
    }
    var sommer = ms >= letzterSonntag(2) && ms < letzterSonntag(9);
    return new Date(ms + (sommer ? 2 : 1) * 3600000).toISOString().slice(0, 10);
  }

  function testGesehen() {
    try {
      if (testGemeldet) return;
      var ab = window.lcAb;
      if (!ab || ab.typ !== 'preisfarbe') return;
      if (!TEST_MUSTER.test(String(ab.test)) || !VARIANTE_MUSTER.test(String(ab.variante))) return;
      testGemeldet = true;
      var schluessel = 'lc_ab_gesehen_' + ab.test;
      var heute = berlinTag(new Date());
      if (L.getItem(schluessel) === heute) return;
      L.setItem(schluessel, heute);
      if (L.getItem(schluessel) !== heute) return;
      melden('test_gesehen', null, null, null);
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
    document.addEventListener('DOMContentLoaded', pdpGesehen);
    document.addEventListener('DOMContentLoaded', testGesehen);
  } else {
    start();
    pdpGesehen();
    testGesehen();
  }
})();
